import portsApi from '@/framework/ports/portsApi';

const LivePersonChatFrontend = {
  activateEngagement: (
    name: string,
    redirectUrl: string,
    iosRedirectUrl: string
  ) =>
    portsApi.invoke('LivePersonChat.activateEngagement', [
      name,
      redirectUrl,
      iosRedirectUrl,
    ]),
  onOpenCashierLiveChat: (callback: Function) =>
    portsApi.on('LivePersonChat.onOpenCashierLiveChat', callback),
};

export default LivePersonChatFrontend;
